module.exports = __webpack_public_path__ + "static/6-bbf387c1b9e4902531090a40cb97ed8a.jpeg";